import numberToWords from "number-to-words";
import sanitizeHtml from 'sanitize-html';
import newRequest from "./newRequest";
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export const calculateAgeFromMongoDate = (mongoDate) => {
  try {
    const birthDate = new Date(mongoDate);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthDate.getFullYear();

    // Check if the birthday has occurred this year
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  } catch (error) {
    console.log(error)
  }
};

// Function to format date to "yyyy-MM-dd"
export const formatDate = (date) => {
  try {
    if (!date) {
      return ""; // Return an empty string if the date is undefined or null
    }

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  } catch (error) {
    console.log(error)
  }
};

export const formatNumberWithDigitGrouping = (number, decimalPlaces = 2) => {
  try {
    return Number(number).toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
  } catch (error) {
    console.log(error)
  }
};

export const numberToWordsWithDecimal = (value) => {
  try {
    // Remove commas and quotes if they exist
    const strippedValue =
      typeof value === "string" ? value.replace(/,|"/g, "") : value;
    let decimalWords = "";
    let integerWords = "";
    let decimalPart;

    // Split the value into integer and decimal parts
    if (!Number.isInteger(strippedValue)) {
      const parts = strippedValue.split(".");
      const integerPart = parseInt(parts[0]);
      decimalPart = parts[1] ? parseInt(parts[1]) : 0;
      // Convert integer part to words
      integerWords = numberToWords.toWords(integerPart);
    } else {
      // Convert integer part to words
      integerWords = numberToWords.toWords(parseInt(strippedValue));
    }
    // Convert decimal part to words

    if (decimalPart > 0) {
      decimalWords = "point ";
      decimalWords += numberToWords.toWords(decimalPart).replace(/ and /g, " ");
    }

    // Combine integer and decimal parts
    let result = integerWords;
    if (decimalWords) {
      result += ` ${decimalWords}`;
    }

    // Capitalize the first letter
    result = result.charAt(0).toUpperCase() + result.slice(1);

    // Add currency if necessary
    // result += " dollars";

    return result;
  } catch (error) {
    console.log(error)
  }
};


// validate vehicle registration number

export const validateMotorVehicleRegn = (str) => {
  try {
    // Regular expression to match the specified format
    const regex = /^[A-Za-z]{3}\d{3}[A-Za-z]$/;

    return regex.test(str);
  } catch (error) {
    console.log(error)
  }
};

export const validateMotorCycleRegn = (str) => {
  try {
    // Regular expression to match the specified format
    const regex = /^[A-Za-z]{4}\d{3}[A-Za-z]$/;

    // Test the input string against the regex
    return regex.test(str);
  } catch (error) {
    console.log(error)
  }
};

export const generateUniqueCode = (length = 10) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
};

export const generateUniqueId = () => {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  // fallback
  return (
    Date.now().toString(36) +
    "_" +
    Math.random().toString(36).substring(2, 15) +
    "_" +
    Math.random().toString(36).substring(2, 15)
  );
};

export const formatStringToNumberV2 = (input) => {
  try {
    if (input) {
      // If input is already a number, return it
      if (typeof input === 'number') {
        return input;
      }

      // If input is not a string, throw an error
      if (typeof input !== 'string') {
        return input;
      }

      // Remove double quotes from the string if they exist
      const stringWithoutQuotes = input.replace(/"/g, "");

      // Check if the string has a comma before replacing it
      const hasComma = stringWithoutQuotes.includes(",");

      // Remove commas from the string if it contains any
      const stringWithoutCommas = hasComma
        ? stringWithoutQuotes.replace(/,/g, "")
        : stringWithoutQuotes;

      // Convert the string to a number
      const numberValue = parseFloat(stringWithoutCommas);
      // Check if the conversion was successful
      if (isNaN(numberValue)) {
        console.log(`Input ${input} is invalid`);
        return input;
      }
      return numberValue;
    }
  } catch (error) {
    console.log(error)
  }
}

// Function to validate email format
export const validateEmail = (email) => {
  try {
    // Regular expression pattern for email validation
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailPattern.test(email); // Returns true if email format is valid, false otherwise
  } catch (error) {
    console.log(error)
  }
};

export const isDateGreater = (date1, date2) => {
  try {
    const date1Only = getDateOnly(date1);
    const date2Only = getDateOnly(date2);
    return date1Only > date2Only;
  } catch (error) {
    console.log(error)
  }
};

export const getDateOnly = (date) => {
  try {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    return new Date(Date.UTC(year, month, day));
  } catch (error) {
    console.log(error)
  }
};

export const formatIntegerToDecimal = (value, decimals = 2) => {
  // Convert number to a string with comma separators and two decimal places
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const validatePhoneNumberKe = (phoneNumber) => {
  try {
    // Regular expression to match the criteria
    const phoneRegex = /^254[1-9]\d{8}$/;
    // Test the phone number against the regex
    return phoneRegex.test(phoneNumber);
  } catch (error) {
    console.log(error)
  }
}


export const getTodaysDateWithoutTime = () => {
  try {
    const today = new Date();
    // Remove the time portion by setting hours, minutes, seconds, and milliseconds to 0
    today.setHours(0, 0, 0, 0);
    // Format the date as YYYY-MM-DD
    const formattedDate = today.toISOString().split('T')[0];
    return formattedDate;
  } catch (error) {
    console.log(error)
  }
};

// Function to compare the MongoDB date with today's date
export const isMongoDateGreaterOrEqualToToday = (mongoDate) => {
  try {
    const date = new Date(mongoDate);
    const mongoDateOnly = getMongoDateOnly(date);

    const today = new Date();
    const todayDateOnly = getMongoDateOnly(today);

    // return mongoDateOnly >= todayDateOnly ? 'Y' : 'N';
    return mongoDateOnly >= todayDateOnly;
  } catch (error) {
    console.log(error)
  }
};

// Utility function to get the date portion only
export const getMongoDateOnly = (date) => {
  try {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.log(error)
  }
};

// Function to check if two dates are equal, excluding the time portion
export const areDatesEqual = (date1, date2) => {
  try {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);

    const dateOnly1 = getDateOnly(parsedDate1);
    const dateOnly2 = getDateOnly(parsedDate2);

    return dateOnly1 === dateOnly2;
  } catch (error) {
    console.log(error)
  }
};

// passed mongoDate is YYYY-MM-DD
export const addMonthsToMongoDate = (mongoDate, monthsToAdd) => {
  try {
    // Parse the MongoDB date string
    const date = new Date(`${mongoDate}T00:00:00Z`);

    // Calculate the new month and year
    const currentMonth = date.getUTCMonth();
    const currentYear = date.getUTCFullYear();
    const newMonth = currentMonth + monthsToAdd;

    // If newMonth is negative or greater than 11, adjust the year and month accordingly
    const adjustedYear = currentYear + Math.floor(newMonth / 12);
    const adjustedMonth = newMonth % 12;

    // Set the new date
    date.setUTCFullYear(adjustedYear);
    date.setUTCMonth(adjustedMonth);

    // Format the date as YYYY-MM-DD
    const formattedDate = date.toISOString().split('T')[0];

    return formattedDate;
  } catch (error) {
    console.log(error);
  }
};



// pass date as YYYY-MM-DD
export const addDaysToMongoDate = (mongoDate, daysToAdd, am = "a") => {
  try {
    // Parse the MongoDB date string
    const date = new Date(`${mongoDate}T00:00:00Z`);


    if (am === "a") {
      // Add the specified number of days
      date.setUTCDate(date.getUTCDate() + daysToAdd);
    } else {
      // Subtract the specified number of days
      date.setUTCDate(date.getUTCDate() - daysToAdd);
    }


    // Format the date as YYYY-MM-DD
    const formattedDate = date.toISOString().split('T')[0];

    return formattedDate;
  } catch (error) {
    console.log(error)
  }
};


export const sanitizeText = (htmlText) => {
  return sanitizeHtml(htmlText, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a'],
    allowedAttributes: {
      'a': ['href']
    },
  });
};


// take in text and replace all tags with actuals
export const replaceTags = (inputText, currentUser) => {
  try {
    const placeholders = {
      insuredName: currentUser?.usr_full_name,
      carrierName: "ABC Insurance",
      clientName: currentUser?.usr_full_name,
      daysToRenewal: '30',
      expiryDate: '31-Mar-XXXX',
      ourCompanyName: currentUser?.usr_org_name,
      ourContactEmail: currentUser?.org_email,
      ourContactPhone: currentUser?.org_phone,
      ourPhysicalAddress: currentUser?.org_address1,
      ourPostalAddress: currentUser?.org_address2,
      ourWebsite: currentUser?.org_website,
      outstandingPremium: '20,000.00',
      policyCurrency: currentUser?.currency_name_xx,
      policyFromDate: '08-Jun-20XX',
      policyToDate: '30-Nov-20XX',
      policyNumber: 'P/2909/HQ/2024/19002',
      policyPremium: '30,000.00',
      policySumInsured: '1,000,000.00',
      productName: 'Public Liability',
      riskNoteNo: 'RN01401'
    };

    return inputText.replace(/{{(.*?)}}/g, (_, key) => placeholders[key.trim()] || '');

  } catch (error) {
    console.log(error)
  }
};

/**
 * Replaces placeholders in a template with corresponding values.
 * @param {string} template - The email template with placeholders.
 * @param {Object} values - An object where keys are placeholders and values are the replacements.
 * @returns {string} - The template with placeholders replaced by actual values.
 */

export const replacePlaceholders = (template, values) => {
  return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    // Return the value if it exists, otherwise return the placeholder as is.
    return values[key] !== undefined ? values[key] : match;
  });
}

export const getAgeNextBirthday = (dob, currentDate) => {
  try {
    // Parse the input dates
    const birthDate = new Date(dob);
    const current = new Date(currentDate);

    // Calculate the current age
    let age = current.getFullYear() - birthDate.getFullYear();

    // Create the next birthday date (next birthday in the current year)
    let nextBirthday = new Date(current.getFullYear(), birthDate.getMonth(), birthDate.getDate());

    // If the next birthday has already passed this year, calculate for next year
    if (nextBirthday < current) {
      nextBirthday.setFullYear(current.getFullYear() + 1);
    }

    // Calculate the difference in time between the current date and the next birthday
    const diffInTime = nextBirthday - current;
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24); // Convert milliseconds to days

    // If the difference is greater than 182 days, increment the age for next year
    if (diffInDays > 182) {
      age += 1;
    }

    return age;
  } catch (error) {
    console.log(error);
  }
}


export const getFutureDay = (daysToAdd) => {
  try {
    // Get today's date
    const today = new Date();

    // Add the given number of days to today's date
    today.setDate(today.getDate() + daysToAdd);

    // Add 5 more days to the new date
    today.setDate(today.getDate() + 5);

    // Return the day of the month
    return today.getDate();
  } catch (error) {
    console.log(error);
    return 15;
  }
}

export const capitalizeFirstLetter = (str) => {
  return str
    .split(' ') // Split the string into an array of words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the array back into a single string
}

export const initCap = (str) => {
  if (!str) return str; // Return the original string if it's empty or undefined
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  });
}


export const calculatePercentage = (amount, percent) => {
  try {
    return Number(parseFloat(((amount * percent) / 100)).toFixed(2));
  } catch (error) {
    console.log(error);
  }
}

export const calculateBasePercentage = (total, value) => {
  if (total === 0) {
    console.log("total cannot be zero.");
    return 0;
  }
  return (value / total) * 100;
}

export const getKeyInArray = (array, key) => {
  const item = array?.find(obj => Object.hasOwn(obj, key));
  return item ? item[key] : "Y";
};


export const fetchClientsBySearch = async (inputValue, callback, entity_types) => {
  try {
    if (inputValue?.length > 2) {
      const res = await newRequest.post("/allEntity/search", { search_input: inputValue, ent_status: "", entity_types });

      const options = res.data?.map((entity) => ({
        ent_docid: entity?._id,
        ent_email: entity?.ent_email,
        ent_type: entity?.ent_type,
        ent_gender: entity?.ent_gender,
        ent_age_xx: entity?.ent_age_xx,
        ent_occupation_xx: entity?.ent_occupation_xx,
        ent_sector_xx: entity?.ent_sector_xx,
        ent_sub_sector_xx: entity?.ent_sub_sector_xx,
        ent_phone_no: entity?.ent_phone_no,
        ent_photo_url: entity?.ent_photo_url,
        ent_status: entity?.ent_status,
        aent_name_xx: entity?.aent_name_xx,
        ent_code: entity?.ent_code,
        ent_aent_code: entity?.ent_aent_code,
        ent_name: entity?.ent_name,
        value: entity?.ent_code,
        label: (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
            {entity?.ent_name}
            {entity?.ent_status !== "Active" && (
              <span style={{ color: "gray" }}> [{entity?.ent_status}]</span>
            )}
          </div>
        ),
        isDisabled: entity?.ent_status !== "Active"
      }));

      callback(options);
    }
  } catch (error) {
    console.error("Error fetching entity types:", error);
    callback([]);
  }
};


export const fetchUsersBySearch = async (inputValue, callback, user_types) => {
  try {
    if (inputValue?.length > 1) {
      const res = await newRequest.post("/adUser/search", { search_input: inputValue, ent_status: "", user_types });
      const options = res.data.map((user) => ({
        usr_full_name: user?.usr_full_name,
        value: user?._id,
        label: (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
            {user?.usr_full_name}
            {user.usr_enabled !== "Y" && (
              <span style={{ color: "gray" }}> [{`Disabled`}]</span>
            )}
          </div>
        ),
        isDisabled: user.usr_enabled !== "Y"
      }));

      callback(options);
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    callback([]);
  }
};

export const fetchAllUsersBySearch = async (inputValue, callback, user_types) => {
  try {
    if (inputValue?.length > 1) {
      const res = await newRequest.post("/adUser/searchAll", { search_input: inputValue, ent_status: "", user_types });
      const options = res.data.map((user) => ({
        usr_full_name: user?.usr_full_name,
        usr_org_name: user?.usr_org_name,
        usr_un: user?.usr_un,
        usr_email: user?.usr_email,
        usr_phone_no: user?.usr_phone_no,
        value: user?._id,
        label: (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
              <span className="sub-title">{user?.usr_full_name}</span>
              <span>|</span>
              <span className="sub-title" style={{ fontSize: "10px" }}>{user?.usr_org_name}</span>
            </div>
            {user.usr_enabled !== "Y" && (
              <span style={{ color: "gray" }}> [{`Disabled`}]</span>
            )}
          </div>
        ),
        isDisabled: user.usr_enabled !== "Y"
      }));

      callback(options);
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    callback([]);
  }
};

export const fetchMainLedgers = async (
  inputValue,
  callback,
  sub_type = []   // e.g. ["Account"] or ["Entity"]
) => {
  try {
    if (inputValue?.length > 0) {
      const res = await newRequest.post("/glMainAccount/search", {
        search_input: inputValue
      });

      let options = res.data.map((ledger) => ({
        ma_sub_type: ledger?.ma_sub_type,
        ma_category: ledger?.ma_category,
        value: ledger?.ma_code,
        label: `${ledger?.ma_name} - [${ledger?.ma_code}]`,
        isDisabled: ledger?.ma_enabled !== "Y"
      }));

      // FILTER ONLY IF sub_type IS PROVIDED
      if (Array.isArray(sub_type) && sub_type.length > 0) {
        options = options.filter(opt =>
          sub_type.includes(opt.ma_sub_type)
        );
      }

      callback(options);
    }
  } catch (error) {
    console.error("Error fetching ledgers:", error);
    callback([]);
  }
};


export const fetchSubLedgers = async (inputValue, callback, mgl_code) => {
  try {
    // ["Asset", "Income", "Liability", "Expense", "Equity"]
    if (inputValue?.length > 1) {
      const res = await newRequest.post("/glSubAccount/search", { search_input: inputValue, sa_ma_code: mgl_code });
      const options = res.data.map((ledger) => ({
        value: ledger?.sa_code,
        label: `${ledger?.sa_name} - [${ledger?.sa_code}]`,
        isDisabled: ledger?.sa_enabled !== "Y"
      }));
      // console.log(`options  ${JSON.stringify(options, null, 2)}`);
      callback(options);
    }
  } catch (error) {
    console.error("Error fetching ledgers:", error);
    callback([]);
  }
};

export const fetchLocationsBySearch = async (inputValue, callback, location_type) => {
  try {
    if (inputValue?.length > 2) {
      const res = await newRequest.post("/location/search", { search_input: inputValue, level_type: location_type });
      const options = res.data.map((loc) => ({
        value: loc?.loc_code,
        label: loc?.loc_name
      }));

      callback(options);
    }
  } catch (error) {
    console.error("Error fetching entity types:", error);
    callback([]);
  }
};


export const fetchJobs = async (inputValue, callback, job_status) => {
  try {
    if (inputValue?.length > 1) {
      const res = await newRequest.post("/hrJob/search", { search_input: inputValue, result_limit: 100, job_status: job_status });
      const options = res.data.map((job) => ({
        value: job?.job_code,
        label: job?.job_status === "Active" ? job?.job_title : `${job?.job_title} : Not Activated`,
        isDisabled: job?.job_status !== "Active"
      }));
      callback(options);
    }
  } catch (error) {
    console.error("Error fetching jobs:", error);
    callback([]);
  }
};

export const fetchPositions = async (inputValue, callback, pos_status) => {
  try {
    if (inputValue?.length > 1) {
      const res = await newRequest.post("/hrPosition/search", { search_input: inputValue, result_limit: 100, pos_status: pos_status });
      const options = res.data.map((pos) => ({
        doc_id: pos?._id,
        value: pos?.pos_code,
        label: pos?.pos_status === "Active" ? pos?.pos_title : `${pos?.pos_title} : Not Activated`,
        isDisabled: pos?.pos_status !== "Active"

      }));
      callback(options);
    }
  } catch (error) {
    console.error("Error fetching positions:", error);
    callback([]);
  }
};

export const fetchSystemCodes = async (inputValue, callback, sysType) => {
  try {
    if (inputValue?.length > 0) {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: sysType });
      const filteredOptions = res.data
        .filter((codes) =>
          codes.sys_name?.toLowerCase().includes(inputValue?.toLowerCase())
        )
        .map((codes) => ({
          value: codes?.sys_code,
          label: codes?.sys_name,
        }));

      callback(filteredOptions);
    } else {
      callback([]);
    }
  } catch (error) {
    console.error("Error fetching entity types:", error);
    callback([]);
  }
};


export const formatAmountsToDecimals = (value, decimals = 2) => {
  if (isNaN(value)) return value;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};

const statusMap = [
  { value: "New", css_value: "Awaiting-otp" },
  { value: "Awaiting OTP", css_value: "Awaiting-otp" },
  { value: "Validated", css_value: "Validated" },
  { value: "Awaiting Approval", css_value: "Awaiting-Approval" },
  { value: "Response Received", css_value: "New" },
  { value: "Awaiting Payment", css_value: "Response-Received" },
  { value: "Partially Paid", css_value: "InProgress" },
  { value: "Fully Paid", css_value: "Opened" },
  { value: "Rejected", css_value: "Rejected" },
  { value: "Fradulent", css_value: "Fradulent" },
  { value: "Closed", css_value: "Closed" },
  { value: "In-Approval", css_value: "InProgress" },
  { value: "Normal", css_value: "Normal" },
  { value: "High", css_value: "High" },
  { value: "Critical", css_value: "Critical" },
  { value: "Cancelled", css_value: "Critical" },
  { value: "In-Quote", css_value: "Response-Received" },
  { value: "In-Quote Request", css_value: "Awaiting-Approval" },
  { value: "Partially Executed", css_value: "Awaiting-Approval" },
  { value: "Paused", css_value: "Response-Received" },
  { value: "Active", css_value: "Active" },
  { value: "Executed", css_value: "Active" },
  { value: "Inactive", css_value: "Response-Received" },
  { value: "Pending", css_value: "High" },
  { value: "Delisted", css_value: "Closed" },
  { value: "Voided", css_value: "Critical" },

  { value: "Buy", css_value: "Opened" },
  { value: "Sell", css_value: "Rejected" },
  { value: "Roll Over", css_value: "Fradulent" },
  { value: "Redeem", css_value: "Closed" },
  { value: "Transfer In", css_value: "InProgress" },
  { value: "Transfer Out", css_value: "Response-Received" },

  { value: "Under Review", css_value: "Awaiting-Approval" },
  { value: "In Grace Period", css_value: "Response-Received" },
  { value: "Expiring Soon", css_value: "Awaiting-Approval" },

  { value: "A_Single", css_value: "Closed" },
  { value: "B_Single", css_value: "Opened" },
  { value: "C_Single", css_value: "New" },
  { value: "D_Single", css_value: "Validated" },

];


// Function to get css_value by value
export const getCssValue = (status) => {
  const found = statusMap.find((item) => item.value === status);
  return found ? found.css_value : "Opened";
};

const riAllocationMap = [
  { value: "Cover", css_value: "Awaiting-otp" },
  { value: "Risk Based", css_value: "Validated" },
  { value: "Top Location", css_value: "Awaiting-Approval" },
  { value: "None", css_value: "Critical" },
];

export const getRiAllocationValue = (status) => {
  const found = riAllocationMap.find((item) => item.value === status);
  return found ? found.css_value : "Opened";
};

export const formatNumber = (value, decimals = 2) => {
  if (isNaN(value)) return value;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};


export const toCamelCase = (str) => {
  if (!str) {
    return str
      .split(/\s+/) // Split by spaces
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
  } else {
    return str;
  }
};


export function calculateYearsMonths(startDate, endDate) {
  // Remove time portion from dates
  let start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  let end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  // Swap dates if start is after end
  if (start > end) {
    [start, end] = [end, start];
  }

  // Calculate full years and months difference
  let months = (end.getFullYear() - start.getFullYear()) * 12;
  months += end.getMonth() - start.getMonth();

  // Adjust for days (since we're inclusive)
  if (end.getDate() < start.getDate()) {
    months--;
  }
  // Add 1 to include both start and end dates
  months++;
  const years = Math.floor(months / 12);
  return { months, years };
}

export const formatAmountsToShort = (value, decimals = 2) => {
  // Define thresholds and suffixes for different ranges
  const thresholds = [
    { limit: 1e12, suffix: "T" }, // Trillions
    { limit: 1e9, suffix: "B" },  // Billions
    { limit: 1e6, suffix: "M" },  // Millions
    { limit: 1e3, suffix: "K" },  // Thousands
  ];

  // If value is less than 1000, return the value as is with the specified decimal places
  if (value < 1000) {
    return value.toFixed(decimals);
  }

  // Iterate over the thresholds to find the correct format
  for (let i = 0; i < thresholds.length; i++) {
    const { limit, suffix } = thresholds[i];

    // Check if the value is greater than or equal to the current limit
    if (value >= limit) {
      // Divide by the limit and format with the specified decimal places
      const formattedValue = (value / limit).toFixed(decimals);
      return `${formattedValue}${suffix}`;
    }
  }

  // Default return as a fallback (this line should not be reached due to thresholds)
  return value.toFixed(decimals);
};


export const getFirstName = (fullName) => {
  if (!fullName) return "";
  return fullName.trim().split(" ")[0];
};

export const getMidnightUTC = (date) => {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  return d;
};

export const getStartOfDayUTC = (date) => {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  return d;
};

export const getEndOfDayUTC = (date) => {
  const d = new Date(date);
  d.setUTCHours(23, 59, 59, 999);
  return d;
};


export const generateColors = (count) =>
  Array.from({ length: count }, (_, i) => `hsl(${(i * 360) / count}, 60%, 60%)`);



export const handleOpenMap = (latitude, longitude) => {
  try {
    // const zoom = 15;
    // const url = `https://www.google.com/maps/@${latitude},${longitude},${zoom}z`;
    // window.open(url, '_blank');
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, '_blank');
  } catch (error) {
    console.log(error);
  }
};

/**
 * Validates an international mobile number.
 * Automatically adds '+' if missing.
 *
 * @param {string} number - Phone number in international format (with or without +).
 * @returns {boolean} - True if it's a valid mobile or fixed-line-mobile number.
 */
export const isValidMobileNumber = (number) => {
  if (!number || typeof number !== 'string') return false;

  // Trim spaces and add '+' if missing
  const formattedNumber = number.trim().startsWith('+') ? number.trim() : `+${number.trim()}`;

  const phoneNumber = parsePhoneNumberFromString(formattedNumber);

  return phoneNumber?.isValid() &&
    ['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(phoneNumber.getType());
};

export const normalizePhoneNumber = (input) => {
  if (!input || typeof input !== 'string') return '';
  return input.trim().replace(/\s+/g, '');
};


export const validateMandatoryDocuments = (requiredDocuments, entType, attachedDocuments) => {
  const missingDocs = [];
  // console.log(`entType ... ${entType}`);
  // console.log(`requiredDocuments ${JSON.stringify(requiredDocuments, null, 2)}`);
  // console.log(`attachedDocuments ${JSON.stringify(attachedDocuments, null, 2)}`);

  // Step 1: Loop through all mandatory documents
  requiredDocuments.forEach((doc) => {

    if (doc.mandatory === "Y" && doc.document_entity_type === entType) {
      const isAttached = attachedDocuments.some(
        (attached) => attached.fl_flag === doc.document_type
      );

      if (!isAttached) {
        missingDocs.push({
          msg_index: missingDocs.length + 1,
          msg_no: `DOC${missingDocs.length + 1}`,
          msg_text: `Mandatory document ${doc.document_type} has not been attached`,
          msg_type: "error",
        });
      }
    }
  });

  // Step 2: Return result
  if (missingDocs.length > 0) {
    return {
      result_status: "error",
      result_msg: "Missing Documents",
      result_msg_list: missingDocs,
    };
  } else {
    return {
      result_status: "success",
      result_msg: "All mandatory documents are attached",
      result_msg_list: [],
    };
  }
}

export const calculateAccruedInterest = ({
  couponRate,
  faceValue,
  lastCouponDate,
  settlementDate,
  dayCountConvention,
  marketType // 'Primary' or 'Secondary'
}) => {
  if (marketType === 'Primary') return 0.00;

  if (!lastCouponDate) {
    throw new Error("lastCouponDate is required for secondary market bonds.");
  }

  const start = new Date(lastCouponDate);
  const end = new Date(settlementDate);

  let daysElapsed;
  let yearBasis;

  switch (dayCountConvention) {
    case '30/360': {
      const d1 = Math.min(start.getDate(), 30);
      const d2 = Math.min(end.getDate(), 30);
      const m1 = start.getMonth();
      const m2 = end.getMonth();
      const y1 = start.getFullYear();
      const y2 = end.getFullYear();
      daysElapsed = (360 * (y2 - y1)) + (30 * (m2 - m1)) + (d2 - d1);
      yearBasis = 360;
      break;
    }
    case 'Actual/360':
      daysElapsed = Math.floor((end - start) / (1000 * 60 * 60 * 24));
      yearBasis = 360;
      break;

    case 'Actual/365':
      daysElapsed = Math.floor((end - start) / (1000 * 60 * 60 * 24));
      yearBasis = 365;
      break;

    case 'Actual/Actual':
    default:
      daysElapsed = Math.floor((end - start) / (1000 * 60 * 60 * 24));
      const year = start.getFullYear();
      const isLeap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
      yearBasis = isLeap ? 366 : 365;
      break;
  }

  const accruedInterest = (couponRate * faceValue * daysElapsed) / yearBasis;
  return parseFloat(accruedInterest.toFixed(2));
};


export const calculateTotalTradeValue = ({
  cleanPricePer100,  // e.g. 95.5
  faceValue,         // e.g. 100000
  accruedInterest    // result from above
}) => {
  const cleanValue = (cleanPricePer100 / 100) * faceValue;
  const totalValue = cleanValue + accruedInterest;
  return parseFloat(totalValue.toFixed(2));
}


/**
 * Calculate T-Bill values from tenor and discount rate.
 * @param {number} faceValue - The maturity value of the bill (e.g. 100000)
 * @param {string|Date} fromDate - Start date of the bill
 * @param {number} tenorDays - Number of days until maturity (e.g. 91)
 * @param {number} discountRate - Discount rate in percent (e.g. 10.5 for 10.5%)
 * @returns {{
 *   maturityDate: string,
 *   purchasePrice: number,
 *   discountedAmount: number,
 *   investedAmount: number,
 *   yieldToMaturity: number,
 *   discountRate: number
 * }}
 */
export const calculateTBillFromDiscountRate = ({ faceValue, fromDate, tenorDays, discountRate }) => {
  if (!faceValue || !fromDate || !tenorDays || !discountRate) {
    throw new Error("All parameters (faceValue, fromDate, tenorDays, discountRate) are required.");
  }
  // Convert from percent to decimal
  const rate = discountRate / 100;
  // Calculate purchase price based on discount rate (based on face value)
  const purchasePrice = parseFloat((faceValue * (1 - (rate * tenorDays / 360))).toFixed(2));
  const discountAmount = parseFloat((faceValue - purchasePrice).toFixed(2));
  const yieldToMaturity = parseFloat(((discountAmount / purchasePrice) * (365 / tenorDays)).toFixed(4));

  const investedAmount = purchasePrice;

  // Compute maturity date
  const maturityDateObj = new Date(fromDate);
  maturityDateObj.setDate(maturityDateObj.getDate() + tenorDays);
  const maturityDate = maturityDateObj.toISOString().split("T")[0];
  const quantity = parseFloat((investedAmount / purchasePrice).toFixed(6));

  return {
    faceValue,
    investedAmount,
    purchasePrice,
    discountAmount,
    discountRate,
    yieldToMaturity: yieldToMaturity * 100,
    fromDate,
    tenorDays,
    maturityDate,
    quantity
  };
}


/**
 * Calculates maturity date and total interest receivable for a fixed deposit.
 * @param {number} principal - Principal amount invested
 * @param {string} interestType - "Simple" or "Compound"
 * @param {number} annualRate - Annual interest rate in percentage (e.g., 12.8)
 * @param {Date} startDate - Start date of the investment
 * @param {number} tenorInDays - Investment period in days
 * @param {number} [compoundFrequency=1] - Times interest is compounded annually (used for compound)
 * @returns {{ maturityDate: Date, interestReceivable: number }} - Maturity date and interest earned
 */
export const calculateFDDetails = ({
  principal,
  interestType = "Simple",
  annualRate,
  startDate,
  tenorInDays,
  compoundFrequency = 1
}) => {
  const msInDay = 1000 * 60 * 60 * 24;
  const maturityDate = new Date(new Date(startDate).getTime() + tenorInDays * msInDay);
  const timeInYears = tenorInDays / 365;
  const rateDecimal = annualRate / 100;

  let interestReceivable = 0;

  if (interestType === "Simple") {
    interestReceivable = principal * rateDecimal * timeInYears;
  } else {
    const n = compoundFrequency;
    const A = principal * Math.pow((1 + rateDecimal / n), n * timeInYears);
    interestReceivable = A - principal;
  }

  return {
    maturityDate,
    interestReceivable: parseFloat(interestReceivable.toFixed(2))
  };
}


export const formatTypeName = (name) => {
  if (!name) return "";
  return name
    .replace(/([a-z])([A-Z])/g, "$1 $2") // insert space between lowercase + uppercase
    .trim(); // remove extra spaces if any
}

export const logData = (label = "logged...", data) => {
  console.log(`${label} : ${JSON.stringify(data, null, 2)}`);
}


export const getLastDigits = (phone, noOfDigits = 10) => {
  if (!phone) return null;

  // Remove all non-numeric characters
  const digits = phone.toString().replace(/\D/g, "");

  // Extract last 8 digits
  const last8 = digits.slice(-noOfDigits);

  // Return as number
  return Number(last8);
}


export const normalizeKenyaPhone = (phone) => {

  if (!phone) return null;

  // Remove all non-numeric characters
  let digits = phone.toString().replace(/\D/g, "");

  // If number starts with country code 254 -> replace with 0
  if (digits.startsWith("254")) {
    digits = "0" + digits.slice(3);
  }

  // If number starts with +254 (after cleaning it becomes 254)
  // already handled above

  // If number has only 9 digits (e.g. 788102145), prepend 0
  if (digits.length === 9) {
    digits = "0" + digits;
  }

  // If already a valid 10-digit number starting with 0, return as is
  if (digits.length === 10 && digits.startsWith("0")) {
    return digits;
  }

  // If invalid, return null or throw error
  return null;
}

export const getLastXDigits = (value, digitsToGet = 5) => {
  if (!value) return null;
  const digits = value.toString().replace(/\D/g, "");
  return digits.length >= digitsToGet ? digits.slice(-digitsToGet) : null;
}


export const getPrefixSafe = (value) => {
  if (!value || typeof value !== "string") return "";
  return value.includes("_") ? value.split("_")[0] : value;
}


export const getInitials = (name = "") => {
  if (!name) return "";

  const parts = name?.trim().split(/\s+/);

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[1][0]).toUpperCase();
};


/**
 * Replaces all occurrences of a character (or substring) in a string.
 * If replaceWith is not provided, the target is removed.
 *
 * @param {string} inputStr - The original string
 * @param {string} target - Character or substring to replace
 * @param {string} [replaceWith=""] - Replacement value (optional)
 * @returns {string}
 */
export const replaceChar = (inputStr, target, replaceWith = "") => {
  if (typeof inputStr !== "string") {
    throw new Error("inputStr must be a string");
  }

  if (!target) {
    return inputStr;
  }

  return inputStr.split(target).join(replaceWith);
}

export const trimString = (value = "") => {
  return String(value).trim();
};


export const removeSpacesAndTabs = (value = "") => {
  return String(value).replace(/[ \t]/g, "");
};


export const getTimeAgo = (date) => {
  if (!date) return "";
  const diffMs = Date.now() - new Date(date).getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  const years = Math.floor(months / 12);
  return `${years}y ago`;
}